import blobApi from "@/api/blob/blobApi";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async fetch({dispatch}, {id}) {
      try {
        const response = await blobApi.fetch(id);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async cancel({dispatch}, form) {
      try {
        const response = await blobApi.cancel(form);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async view(_, {id}) {
      const response = await blobApi.requestDownload(id);
      window.open(response.data);
    }
  }
}
